import { useRef } from "react";
import { motion, useInView } from "framer-motion";

// Fade + rise reveal driven by a reliable useInView hook (works with Lenis).
export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.15 });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

// Masked line-by-line reveal for large headings.
export const MaskedLines = ({
  lines = [],
  className = "",
  lineClass = "",
  immediate = false,
}) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.2 });
  const show = immediate || inView;
  return (
    <div className={className} ref={ref}>
      {lines.map((line, i) => (
        <div key={i} className="overflow-hidden">
          <motion.div
            initial={{ y: "110%" }}
            animate={{ y: show ? "0%" : "110%" }}
            transition={{
              duration: 0.85,
              delay: 0.08 * i,
              ease: [0.16, 1, 0.3, 1],
            }}
            className={lineClass}
          >
            {line}
          </motion.div>
        </div>
      ))}
    </div>
  );
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -80 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
